define('viewmodels/configuration/UserSupportTemplates',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger', 'viewmodels/GeneralSettings', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, system, logger, ObjGeneralSettings, utils) {

        var ViewModel = {
            activate: activate,
            attached: attached,
            appsecurity: appsecurity,
            utils: utils,
            ObjGeneralSettings: ObjGeneralSettings,
            ControlsAccess: ko.observable(false),
            trEvent: ko.observable(),
            popUpTitle: ko.observable(''),
            addPopUpCss: ko.observable(false),
            TemplateName: ko.observable(''),
            TemplateBody: ko.observable(''),
            TemplateId: ko.observable(0),
            TemplateDescription: ko.observable(),
            GeneralUserSupport: ko.observable(''),
            PrivacyContent: ko.observable(''),
            CookiesContent: ko.observable(''),
            TermsContent: ko.observable(''),
            ContactUsContent: ko.observable(''),
           // LoggedInUser: ko.observable(false),
            UserSupportList: ko.observableArray([]),
            FAQSupportList: ko.observableArray([]),
            GenSupportList: ko.observableArray([]),
           // ShowGeneralManual: ShowGeneralManual,
            //UserContent: ko.observable(''),
            ShowEditPopUp: ShowEditPopUp,
            UpdateUMTemplate: UpdateUMTemplate,
            USMtabsList: ko.observableArray([]),
            USMTabClick: USMTabClick,
            //FAQ
            OpenFAQHeaderPopup: OpenFAQHeaderPopup,
            OpenFAQHeaderEditPopup: OpenFAQHeaderEditPopup,
            AddFAQHeader: AddFAQHeader,
           // BackToSupportList: BackToSupportList,
            UserFAQHeaderList: ko.observableArray([]),
            SelectedFAQHeaderDetails: ko.observable(''),
            deleteValueFunctionality: deleteValueFunctionality,
            deleteFAQheader: deleteFAQheader,
            trclick: trclick,
            addSubLevelFunctionality: addSubLevelFunctionality,
            SubLevelValueList: ko.observableArray([]),
            MainUserSupportList: ko.observableArray([]),
            currentTarget: ko.observable(''),
            CurrentGroup: ko.observable(''),
            LocaleCheckFlag: ko.observable(false),
            CurrentFAQGroup: ko.observable(''),
            IsGenFlag: ko.observable(0),
            CreateUpdateFAQItemTemplate: CreateUpdateFAQItemTemplate,
            UserContactUsList: ko.observableArray([]),
            UpdateContactUsTemplate: UpdateContactUsTemplate,
            ContactTemplateId: ko.observable(0),
            ContactTemplateBody: ko.observable(''),
            ShowViewPopUp: ShowViewPopUp,
            ViewTemplateContent: ko.observable(''),
            RemainingChars: ko.observable(4000),
            CommentCharsLimit: ko.observable(4000),
            ProgressPercent: ko.observable(),
            ProgressMessage: ko.observable(''),
            UploadDocument: UploadDocument,
            DocumentListFinal: ko.observableArray([]),
            GetUMSDocDetails: GetUMSDocDetails,
            CurrentUMSContent: ko.observable(''),
            CurrentUMSId: ko.observable(''),
            OcKeyUp: OcKeyUp,
            OcKeypress: OcKeypress,
            UploadUMSComment: ko.observable(''),
            DownloadDocument: DownloadDocument,
            DeleteDocument: DeleteDocument
        };
        return ViewModel;

        function activate() {
            try {

                if (ViewModel.ObjGeneralSettings === undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((ViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && ViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    ViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (ViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() == null || ViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            ViewModel.LocaleCheckFlag(false);
                        else
                            ViewModel.LocaleCheckFlag(true);
                    });
                } else
                    ViewModel.LocaleCheckFlag(true);

                ViewModel.BUTitle((ViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() == null || ViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ViewModel.ObjGeneralSettings.LocalizedIndexList() == null || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in LocalizationModule.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                if (appsecurity.WriteAccess() == true) {
                    ViewModel.ControlsAccess(true);
                }
                else {
                    ViewModel.ControlsAccess(false);
                }
              
                GetTabs();
                GetUserManualList();
                GetAllFAQLevels();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in LocalizationModule.js';
                logger.logMessage(msg);
            }
        }

        function GetTabs() {
            try {
                var jsonResult = [{ 'TabId': 1, 'TabName': 'FAQ', 'TabTitle': 'Frequently asked questions' },
                    { 'TabId': 2, 'TabName': 'User support', 'TabTitle': 'User support'}, { 'TabId': 3, 'TabName': 'Contact Us', 'TabTitle': 'Contact Us' }];

                var MappedTabDetails = $.map(jsonResult, function (result) {
                    return new UMStabmodel(result);
                });

                ViewModel.USMtabsList(MappedTabDetails);
                $('#1').addClass('active');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetTabs() method in UserManualSetup.js';
                logger.logMessage(msg);
            }
        }

        
        function USMTabClick(data, event) {
            try {
                $('#1').removeClass('active');
                $('#2').removeClass('active');
                $('#3').removeClass('active');

                if (data.TabId() == 1) {
                    //FAQ
                    $("#mainPageContent").hide();
                    $("#subPageContent").show();
                    $("#ContactUsContent").hide();
                    $('#' + data.TabId()).addClass('active');

                } else if (data.TabId() == 2) {
                    //User support
                    $("#mainPageContent").show();
                    $("#subPageContent").hide();
                    $("#ContactUsContent").hide();
                    $('#' + data.TabId()).addClass('active');

                } else {
                    //ContactUs
                    $("#mainPageContent").hide();
                    $("#subPageContent").hide();
                    $("#ContactUsContent").show();
                    $('#' + data.TabId()).addClass('active');
                    
                }
               
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: USMTabClick() method in UserManualSetup.js';
                logger.logMessage(msg);
            }
        }

        function GetUserManualList() {
            try {
                var headers = appsecurity.getSecurityHeaders();
                return $.ajax({
                    url: "/api/Configuration/GetUserSupportList",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {

                        if (jsonResult == null || jsonResult.length == 0)
                            logger.logMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoUserSupportData') == -1) ? 'No data available for user support.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoUserSupportData')].Name(), 'Warning', system.getModuleId(ViewModel), true);
                        else {
                            ViewModel.UserSupportList([]);
                            ViewModel.UserContactUsList([]);
                            ViewModel.MainUserSupportList([]);
                            var MappedGroupDetails = $.map(jsonResult, function (result) {
                                if (result.Identifier != 'ContactUs' && result.Identifier != 'faqList' && result.Is_GeneralSupport === '')
                                    return new UserSupportModel(result);
                            });

                            var MappedContactUs = $.map(jsonResult, function (result) {
                                if (result.Identifier === 'ContactUs')
                                    return new UserSupportModel(result);
                            });

                            var MappedMainGroupDetails = $.map(jsonResult, function (result) {
                                if (result.Group != '' && result.Group != null)
                                    return new UserSupportModel(result);
                            });
                            ViewModel.MainUserSupportList(MappedMainGroupDetails);

                            var MappedGenSupportList = $.map(jsonResult, function (result) {
                                if (result.Is_GeneralSupport === "1")
                                    return new UserSupportModel(result);
                            });

                            var MappedFAQList = $.map(jsonResult, function (result) {
                                if (result.Is_GeneralSupport === "0")
                                    return new UserSupportModel(result);
                            });
                            
                            ViewModel.FAQSupportList(MappedFAQList);
                            ViewModel.GenSupportList(MappedGenSupportList);

                            $('#tblTemplateDetails').show();
                            $('#loadingMainImgDiv').hide();

                            tableObj = $('#tblTemplateDetails').DataTable();
                            tableObj.destroy();

                            $('#tblTemplateDetails tbody tr').remove();
                            QuestionTableObj = undefined;
                            //ViewModel.UserSupportList([]);
                            ViewModel.UserSupportList(MappedGroupDetails);
                            QuestionTableObj = $('#tblTemplateDetails').DataTable({
                                "order": [],
                                "aaSorting": [],
                                "bResponsive": true,
                            });

                            $('#tblTemplateDetails').DataTable().draw(false);

                            for (var i = 0; i < ViewModel.MainUserSupportList().length; i++) {
                                if (ViewModel.MainUserSupportList()[i].Group() === ViewModel.CurrentGroup()) {
                                    ViewModel.SubLevelValueList().push(ViewModel.MainUserSupportList()[i]);
                                }
                            }
                            if (ViewModel.trEvent() != undefined && ViewModel.trEvent() != null && ViewModel.trEvent() != '') {
                                var tr = $(ViewModel.trEvent().currentTarget).closest('tr');
                                var row = OLTableObj.row($(ViewModel.trEvent().currentTarget).closest('tr'));
                                ViewModel.currentTarget($(ViewModel.trEvent().currentTarget).closest('tr').get(0)._DT_RowIndex);
                                checkExpandedRow(row, false);
                                if (row.child.isShown()) {
                                    //close the open row
                                    row.child.hide();
                                    tr.removeClass('shown');
                                }
                                trclick(1, ViewModel.trEvent());
                            }
                           
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UserManualContactAdminError') == -1) ? 'An error has occurred while fetching the User support list. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UserManualContactAdminError')].Name(), 'Error', system.getModuleId(ViewModel), true);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetUserManualList() method in UserManual.js';
                logger.logMessage(msg);
            }
        }

        function UserSupportModel(item) {
            try {
                var self = this;
                    self.ID = ko.observable(item.ID);
                    self.ClientId = ko.observable(item.ClientId);
                    self.Name = ko.observable($('<div/>').html(item.Name).text());
                    self.NameIdentifier = ko.observable($('<div/>').html(item.Identifier).text());
                    self.Is_GeneralSupport = ko.observable(item.Is_GeneralSupport);
                    self.Description = ko.observable($('<div/>').html(item.Description).text());
			        self.rawDescription = ko.observable(item.Description);
                    self.DocumentName = ko.observable($('<div/>').html(item.DocumentName).text());
                    self.DocumentLink = ko.observable($('<div/>').html(item.DocumentLink).text());
                    self.Group = ko.observable($('<div/>').html(item.Group).text());

                if (item.Identifier === 'ContactUs') {
                    ViewModel.ContactTemplateId(self.ID());
                    ViewModel.ContactTemplateBody(self.rawDescription())
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LocalizationModel() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }

        function UserFAQHeaderModel(item) {
            try {
                var self = this;
                self.TemplateId = ko.observable(item.TemplateId);
                self.TemplateName = ko.observable($('<div/>').html(item.TemplateName).text());
                self.TemplateDescription = ko.observable($('<div/>').html(item.TemplateDescription).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LocalizationModel() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }

        function UMStabmodel(item) {
            try {
                var self = this;
                self.TabId = ko.observable(item.TabId);
                self.TabName = ko.observable($('<div/>').html(item.TabName).text());
                self.TabTitle = ko.observable($('<div/>').html(item.TabTitle).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UMStabmodel() method in UMS.js';
                logger.logMessage(msg);
            }
        }

        function UpdateContactUsTemplate(data, event) {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/CreateUpdateTemplate",
                    headers: headers,
                    type: "POST",
                    data: { TemplateBody: $("#TemplateContactEdit").val(), TemplateId: ViewModel.ContactTemplateId(), TemplateName: "ContactUs" }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SaveNewTemplate() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (!jsonResult.startsWith('INC') && parseInt(jsonResult) >= 1) {
                        logger.logSuccess('Template has been updated successfully.', 'Success', system.getModuleId(ViewModel), true);
                        GetUserManualList();
                        //ContactUs
                        $("#mainPageContent").hide();
                        $("#subPageContent").hide();
                        $("#ContactUsContent").show();

                    }
                    else {
                        if (jsonResult.startsWith('INC')) {
                            var msg = 'An error occurred while editing the template. Please contact your Administrator.';
                            logger.logError(jsonResult + ' - ' + msg, 'Error', system.getModuleId(ViewModel), true);
                        }
                        else {
                            logger.logError('An error occurred while editing the template. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from SaveNewTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveNewTemplate() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from SaveNewTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
        }

        function UpdateUMTemplate(data, event) {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/CreateUpdateTemplate",
                    headers: headers,
                    type: "POST",
                    data: { TemplateBody: $("#TemplateBodyEdit").val(), TemplateId: ViewModel.TemplateId(), TemplateName: ViewModel.TemplateName() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SaveNewTemplate() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (!jsonResult.startsWith('INC') && parseInt(jsonResult) >= 1) {
                        logger.logSuccess('Template has been updated successfully.', 'Success', system.getModuleId(ViewModel), true);
                        GetUserManualList();
                        $('#CreateNewTemplate').modal('hide');
                    }
                    else {
                        if (jsonResult.startsWith('INC')) {
                            logger.logError(jsonResult + ' - An error occurred while editing the template. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                        }
                        else {
                            logger.logError('An error occurred while editing the template. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from SaveNewTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveNewTemplate() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from SaveNewTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
        }

        function ShowEditPopUp(data, event) {
            try {
                ViewModel.TemplateId(data.ID());
                ViewModel.popUpTitle("Edit " + data.Name() + " template");
                ViewModel.addPopUpCss(false);
                ViewModel.TemplateName(data.Name());
                ViewModel.TemplateBody(data.rawDescription());
                if (data.NameIdentifier() != "faqList")
                    $('#EditTemplate').modal('show');
                else {
                    //$('#EditFAQTemplate').modal('show');
                    ViewModel.popUpTitle("Add " + data.Name() + " Header");
                    GetAllFAQLevels();
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ShowEditRolePopUp() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
        }
        
       
        function OpenFAQHeaderPopup(data) {
            try {
                $('#valcreateerrorHeader').hide();
                ViewModel.TemplateId('');
                ViewModel.TemplateDescription('');
                ViewModel.popUpTitle("Add Header");
                $('#FAQHeaderPopup').modal('show');
                $('#FAQHeaderIdentifier').val('');
                $('#FAQHeaderName').val('');
                $('#FAQHeaderIdentifier').css({
                    'color': '#000000!important',
                    'cursor': 'unset',
                    'font-weight': 'unset'
                });
                $('#FAQHeaderIdentifier').attr("disabled", false);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OpenFAQHeaderPopup() method in UserSupportTemplate.js';
                logger.logMessage(msg);
            }
        }

        function OpenFAQHeaderEditPopup(data) {
            try {
                ViewModel.TemplateId(data.TemplateId());
                ViewModel.TemplateDescription(data.TemplateDescription());
                $('#valcreateerrorHeader').hide();
                $('#FAQHeaderPopup').modal('show');
                $('#FAQHeaderIdentifier').val('');
                $('#FAQHeaderName').val('');
                $('#FAQHeaderIdentifier').css({
                    'color': '#000000!important',
                    'cursor': 'unset',
                    'font-weight': 'unset'
                });

                if (data != undefined && data != null) {
                    if (data.TemplateDescription() != undefined && data.TemplateDescription() != null) {
                        ViewModel.popUpTitle("Edit " + data.TemplateName() + " Header");
                        $('#FAQHeaderIdentifier').val(data.TemplateDescription());
                        $('#FAQHeaderName').val(data.TemplateName());
                        $('#FAQHeaderIdentifier').css({
                            'color': '#bababa!important',
                            'cursor': 'not-allowed',
                            'font-weight': 'bold'
                        });
                        $('#FAQHeaderIdentifier').attr("disabled", true);
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in OpenFAQHeaderEditPopup() method in UserSupportTemplate.js';
                logger.logMessage(msg);
            }
        }

        function AddFAQHeader() {
            try {
                try {
                    $('#valcreateerrorHeader').hide();
                    var FAQHeaderName = $("#FAQHeaderName").val();

                    if (FAQHeaderName.trim() == "" || FAQHeaderName == undefined) {
                        $('#valcreateerrorHeader').show();
                        document.getElementById('valcreateerrorHeader').innerHTML = "Header Name cannot be empty";
                        return false;
                    }
                    // logic to handle unique identifiers for headers
                    var FAQHeaderIdentifier = '';
                    if (ViewModel.TemplateDescription() != '') {
                        FAQHeaderIdentifier = ViewModel.TemplateDescription();
                    }
                    else {
                        var FAQHeaderIdentifier = FAQHeaderName.match(/\b([a-zA-Z])/g).join('').toUpperCase();
                        var max = -1;
                        ko.utils.arrayFilter(ViewModel.UserFAQHeaderList(), function (arr) {
                            if (max < arr.TemplateId())
                                max = arr.TemplateId();
                        });
                        FAQHeaderIdentifier += '_' + (max + 1);
                    }
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/configuration/CreateUpdateFAQHeader",
                        headers: headers,
                        type: "POST",
                        data: { TemplateId: ViewModel.TemplateId(), TemplateDescription: FAQHeaderIdentifier, TemplateName: FAQHeaderName }
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in SaveNewTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
                function ajaxSuccess(jsonResult, status) {
                    try {
                        if (!jsonResult.startsWith('INC') && parseInt(jsonResult) >= 1) {
                            $('#FAQHeaderPopup').modal('hide');
                            logger.logSuccess('Template has been updated successfully.', 'Success', system.getModuleId(ViewModel), true);
                            GetAllFAQLevels();
                        }
                        else {
                            if (jsonResult.startsWith('INC')) {
                                logger.logError(jsonResult + ' - An error occurred while editing the template. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                            }
                            else {
                                logger.logError('An error occurred while editing the template. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                            }
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from SaveNewTemplate() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                }
                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveNewTemplate() method in EmailTemplate.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail from SaveNewTemplate() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ShowEditRolePopUp() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
        }

        function GetAllFAQLevels() {
            try {
               
                var headers = appsecurity.getSecurityHeaders();
                return $.ajax({
                    url: "/api/Configuration/GetFAQHeaderList",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {

                        if (jsonResult == null || jsonResult.length == 0) {
                            ViewModel.UserFAQHeaderList([]);
                            GetFactorTabData(ViewModel.UserFAQHeaderList([]));
                            OLTableObj = $('#tblOrgLevels').DataTable({
                                "aoColumnDefs": [{
                                    "aTargets": [0],
                                    "bVisible": true,
                                    "sClass": "details-control"

                                }, {
                                    "aTargets": [1],
                                    "bVisible": false,
                                    "bSortable": false

                                    }, {
                                        "aTargets": [2],
                                        "bVisible": true,
                                        "bSortable": false

                                    },
                                    {
                                        "aTargets": [3],
                                        "bVisible": true,
                                        "bSortable": false

                                    },
                                {
                                    "aTargets": [4],
                                    "bSortable": false,
                                    "sClass": "text-center",
                                    "bVisible": ViewModel.ControlsAccess()
                                }]
                            });
                            $('#tblOrgLevels').DataTable().draw(false);

                            logger.logMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoUserSupportData') == -1) ? 'No data available for user support.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoUserSupportData')].Name(), 'Warning', system.getModuleId(ViewModel), true);
                        } else {
                            ViewModel.UserFAQHeaderList([]);

                            var MappedGenSupportList = $.map(jsonResult, function (result) {
                                return new UserFAQHeaderModel(result);
                            });

                            ViewModel.UserFAQHeaderList(MappedGenSupportList);

                            GetFactorTabData(ViewModel.UserFAQHeaderList());

                            //OLTableObj = $('#tblOrgLevels').DataTable();
                            //OLTableObj.destroy();
                            //$("#tblOrgLevels tbody tr").remove();

                            OLTableObj = $('#tblOrgLevels').DataTable({


                                "aoColumnDefs": [{
                                    "aTargets": [0],
                                    "bVisible": true,
                                    "bSortable": false,

                                    "sClass": "details-control"

                                }, {
                                    "aTargets": [1],
                                    "bVisible": false,
                                    "bSortable": false

                                    }, {
                                        "aTargets": [2],
                                        "bVisible": true,
                                        "bSortable": false

                                    },  {
                                        "aTargets": [3],
                                        "bVisible": true,
                                        "bSortable": false

                                    },
                                {
                                    "aTargets": [4],
                                    "bSortable": false,
                                    "sClass": "text-center",
                                    "bVisible": ViewModel.ControlsAccess()
                                }]
                            });

                            $('#tblOrgLevels').DataTable().draw(false);
                        }
                        ko.applyBindingsToNode($('#tblOrgLevels tbody .details-control'), { click: ViewModel.trclick }, ViewModel);
                    })
                    .fail(function (error, status) {
                        logger.logError((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UserManualContactAdminError') == -1) ? 'An error has occurred while fetching the User support list. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UserManualContactAdminError')].Name(), 'Error', system.getModuleId(ViewModel), true);
                    })

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllBusinessLevels() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }

        }

        //Adds the Table HTML
        function GetFactorTabData(data) {
            try {
                var HtmlBody = '<table id="tblOrgLevels" class="table table-bordered border-0 no-footer dataTable" cellspacing="0">'
                HtmlBody += '<thead>'
                HtmlBody += '<tr>'
                HtmlBody += '<th class="site_name"></th>'
                HtmlBody += '<th class="site_name d-none" >FAQ Id</th>'
                HtmlBody += '<th class="site_name text-left">Name</th>';
                HtmlBody += '<th class="site_name d-none">Group</th>'
                HtmlBody += '<th class="parent_action" style="text-align:center;">Actions</th>'
                HtmlBody += '</tr>' +
                    '</thead>' +
                    '<tbody data-bind="foreach: UserFAQHeaderList">' +
                    '<tr>' +
                    '<td class="details-control action-bgcolor"><div style="display:none"></div></td>' +
                    '<td style="display:none" data-bind="text: TemplateId"></td>' +
                    '<td class="text-left" data-bind="text: TemplateName"></td>' +
                    '<td style="display:none" class="text-left" data-bind="text: TemplateDescription"></td>' +
                    '<td class="text-center action-bgcolor">' +
                    '<a href="javascript:void(0)" class="btn-borderless widget-button" data-bind="attr:{title: \'Edit\' },click:$root.OpenFAQHeaderEditPopup">' +
                    '<i class="demo-icon icon-file_edit_special"></i>' +
                    '</a>' +
                    '<a href="javascript:void(0)" class="btn-borderless widget-button" data-bind="attr:{title: \'Delete\' },click: $root.deleteFAQheader">' +
                    '<i class="demo-icon icon-bin_special"></i>' +
                    '</a>' +
                    '</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>';
                document.getElementById('adddivtabbody').innerHTML = HtmlBody;
                ko.applyBindingsToNode($('#tblOrgLevels').find('tbody').get(0), { foreach: ViewModel.UserFAQHeaderList() }, ViewModel);
                //var selected = new UserFAQHeaderModel({ TemplateId: data.TemplateId(), TemplateName: data.TemplateName() });
                //ViewModel.SelectedFAQHeaderDetails(selected);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetFactorTabData() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        //On click of details column
        function trclick(data, event) {
            try {
                ViewModel.trEvent(event);
                var tr = $(event.currentTarget).closest('tr');
                var row = OLTableObj.row($(event.currentTarget).closest('tr'));
                ViewModel.currentTarget($(event.currentTarget).closest('tr').get(0)._DT_RowIndex);
                checkExpandedRow(row, false);
                if (row.child.isShown()) {
                    //close the open row
                    row.child.hide();
                    tr.removeClass('shown');
                }
                else {
                    // Open this row
                    row.child(format(row.data())).show();
                    tr.addClass('shown');
                    ko.applyBindingsToNode($('#subfactor').find('tbody').get(0), { foreach: ViewModel.SubLevelValueList() }, ViewModel);
                    ko.applyBindingsToNode($('#addSubFactorBtn'), { disabled: true, click: ViewModel.addSubLevelFunctionality }, ViewModel);
                    RfSubFactorTableObj = $("#subfactor").DataTable({
                        "bInfo": true,
                        "bResponsive": true,
                        "bPaginate": true,

                        "aoColumnDefs": [{
                            "aTargets": [0],
                            "bVisible": false
                        }, {
                            "aTargets": [1],
                            "bSortable": true
                        },
                        {
                            "aTargets": [2],
                            "bSortable": true
                        },
                        {
                            "aTargets": [3],
                            "bSortable": false,
                            "sClass": "text-center",
                            "bVisible": ViewModel.ControlsAccess()

                        }]
                    });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: trclick() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function checkExpandedRow(row, isPaginating) {
            try {
                
                var currentRowIndex;
                var rowsInTable = $('#tblOrgLevels').find('tr');
                if (isPaginating)
                    currentRowIndex = -1;
                else
                    currentRowIndex = row.index();
                var info = OLTableObj.page.info();
                for (var i = 1, j = (rowsInTable.length); i < j; i++) {
                    var tr = $('#tblOrgLevels').find('tr').get(i);
                    if (OLTableObj.row(tr).index() != row.index()) {
                        var tableRowIndex = (info.page * info.length) + (i - 1);

                        if ((OLTableObj.row(tableRowIndex).child() != undefined) && (OLTableObj.row(tableRowIndex).child.isShown())) {
                            OLTableObj.row(tableRowIndex).child.remove();
                            tr.removeAttribute('class', 'shown')
                            j = $('#tblOrgLevels').find('tr').length;
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function format(data) {
            try {
                
                var Group = data[3];
                ViewModel.CurrentGroup(Group);
                ViewModel.SubLevelValueList([]);
                for (var i = 0; i < ViewModel.MainUserSupportList().length; i++) {
                    if (ViewModel.MainUserSupportList()[i].Group() === Group) {
                        ViewModel.SubLevelValueList().push(ViewModel.MainUserSupportList()[i]);       
                    }
                }
                var SfHtml = '<div class="child-active" style="margin-left:3em;">' +
                    '<div class="panel panel-success panel-margin">' +
                    '<div class="panel-heading">' +
                    '<h5 class="panel-title riskFactorCellPanel mt-2 mb-2 text-left">Sub Levels';
                if (ViewModel.ControlsAccess()) {
                    SfHtml += '<button id="addSubFactorBtn" class="primary-btn pull-right" style="margin-top:-15px;" data-bind="click: $root.addSubLevelFunctionality" title="Click to add new entry">' +
                        '<i class="fa fa-plus"></i> Add Sub Levels' +
                        '</button>';
                }
                SfHtml += '</h5>' +
                    '</div>' +
                    '</div>' +
                    '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subfactor-margin">' +
                    '<table id="subfactor" class="dataTable table-bordered" cellspacing="0">' +
                    '<thead>' +
                    '<tr>' +
                    '<th style="display:none">ID</th>' +
                    '<th class="site_name" style="padding-left: 0.5rem !important;">Name</th>' +
                    '<th class="site_name">Template Content</th>' +
                    '<th class="actions" style="text-align:center;">Actions</th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody data-bind="foreach: SubLevelValueList">' +
                    '<tr>' +
                    '<td style="display:none" data-bind="text: ID"></td>' +
                    '<td class="text-left Rvalues" style="width: 25%; vertical-align: top !important;padding-left: 0.5rem !important;" data-bind="text: Name"></td>' +
                    '<td class="text-left templateDescription" style="width: 55%" data-bind="attr:{\'title\': Description}">' +
                        '<a href="javascript:void(0)" class="btn-borderless widget-button" data-bind="click: $root.ShowViewPopUp">View Template</a>'+
                    '</td > ' +
                    '<td class="text-center" style="width: 15%">' +
                    '<a href="javascript:void(0)" title="Edit" class="btn-borderless widget-button" data-bind="click: $root.ShowEditPopUp">' +
                    '<i class="demo-icon icon-file_edit_special"></i>' +
                    '</a>' +
                    '<a href="javascript:void(0)" title="Documents" class="btn-borderless widget-button" data-bind="click:$root.GetUMSDocDetails">'+
                       ' <i class="demo-icon icon-paperclip_special"></i>'+
                    '</a>'+
                    '<a href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.deleteValueFunctionality">' +
                    '<i class="demo-icon icon-bin_special"></i>' +
                    '</a>' +
                    '</td>' +
                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>';

                return SfHtml;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: format() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function ShowViewPopUp(data) {
            try {
                ViewModel.ViewTemplateContent(data.rawDescription());
                ViewModel.popUpTitle(data.Name());
                //if (data.CurrentGroup() === 'FAQ')
                //    ViewModel.IsGenFlag(0);
                //else
                //    ViewModel.IsGenFlag(1);

                $('#ShowViewPopUp').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowViewPopUp() method in UserSupportTemplates.js';
                logger.logMessage(msg);
            }
        }
      
        function addSubLevelFunctionality(data) {
            try {
                $('#valcreateerrorSL').hide();
                $('#TemplateName').val('');
                $('#TemplateIdentifier').val('');
                $('#TemplateBody').val('');
                ViewModel.popUpTitle('Add Template');
                ViewModel.CurrentFAQGroup(data.CurrentGroup());
                if (data.CurrentGroup() === 'FAQ')
                    ViewModel.IsGenFlag(0);
                else
                    ViewModel.IsGenFlag(1);

                $('#CreateUpdateFAQItemTemplate').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addSubLevelFunctionality() method in UserSupportTemplates.js';
                logger.logMessage(msg);
            }
        }

        function CreateUpdateFAQItemTemplate() {
            try {
                $('#valcreateerrorSL').hide();
                if ($("#TemplateName").val().trim() == "" || $("#TemplateName").val() == undefined) {
                    $('#valcreateerrorSL').show();
                    document.getElementById('valcreateerrorSL').innerHTML = "Template Name cannot be empty";
                    return false;
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/CreateUpdateFAQItemTemplate",
                    headers: headers,
                    type: "POST",
                    data: {
                        TemplateName: $('#TemplateName').val(), TemplateDescription: $('#TemplateName').val()
                        , TemplateBody: $('#TemplateBody').val(), IsGenFlag: ViewModel.IsGenFlag()
                        , TemplateSubject: ViewModel.CurrentFAQGroup()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in SaveNewTemplate() method in EmailTemplate.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (!jsonResult.startsWith('INC') && parseInt(jsonResult) >= 1) {
                        $('#CreateUpdateFAQItemTemplate').modal('hide');

                        logger.logSuccess('Template has been created successfully.', 'Success', system.getModuleId(ViewModel), true);
                        GetUserManualList();
                    }
                    else {
                        if (jsonResult.startsWith('INC')) {
                            logger.logError(jsonResult + ' - An error occurred while creating the template. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                        }
                        else {
                            logger.logError('An error occurred while creating the template. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                        }
                    }

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from SaveNewTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveNewTemplate() method in EmailTemplate.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from SaveNewTemplate() method in EmailTemplate.js';
                    logger.logMessage(msg);
                }
            }
        }
        
        function deleteFAQheader(data, event) {
            try {
                app.showMessage('Are you sure you want to delete? Once deleted, it cannot be undone.', (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete') == -1) ? 'Delete' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete')].Name(), [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name])
                    .then(function (option) {
                        var confirmText = ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                        if (option === confirmText) {
                            DeleteFAQHeaderItem(data, event);
                        }
                    });

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:deleteValueFunctionality() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function DeleteFAQHeaderItem(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/DeleteFAQHeaderItem",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        TemplateDescription: data.TemplateDescription()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {
                    if (!result.startsWith('INC') && parseInt(result) >=0) {
                        var targetRow = $(event.currentTarget).closest("tr").get(0);
                        OLTableObj.row(targetRow).remove().draw(false);
                        logger.logSuccess('Template deleted successfully.', 'Success', system.getModuleId(ViewModel), true);
                        GetAllFAQLevels(); 
                    }
                    else {
                        if (result.startsWith('INC')) {
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(result + ' - ' + msg, 'Error', system.getModuleId(ViewModel), true);
                        
                        }
                        else {
                            logger.logError((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(ViewModel), true);
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    } else {
                        var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }

        }



        function deleteValueFunctionality(data, event) {
            try {
                app.showMessage('Are you sure you want to delete? Once deleted, it cannot be undone.', (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete') == -1) ? 'Delete' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete')].Name(), [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name])
                    .then(function (option) {
                        var confirmText = ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                        if (option === confirmText) {
                            DeleteFAQItem(data, event);
                        }
                    });

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:deleteValueFunctionality() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
        }

        function DeleteFAQItem(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/DeleteFAQItem",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        TemplateId: data.ID()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {
                    if (!result.startsWith('INC') && parseInt(result) >= 0) {
                        var targetRow = $(event.currentTarget).closest("tr").get(0);
                        //data.TargetRow(targetRow._DT_RowIndex);
                        RfSubFactorTableObj.row(targetRow).remove().draw(false);
                        logger.logSuccess('Template deleted successfully.', 'Success', system.getModuleId(ViewModel), true);
                       // GetAllFAQLevels(); 
                       // GetUserManualList();
                    }
                    //else if (result == 0) {
                    //    logger.logWarning('No such template exists. Please refresh the page again and perform the delete operation.', 'Warning', system.getModuleId(ViewModel), true);
                    //}
                    else {
                        if (result.startsWith('INC')) {
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(result + ' - ' + msg, 'Error', system.getModuleId(ViewModel), true);

                        }
                        else {
                            logger.logError((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(ViewModel), true);
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    } else {
                        var msg = 'Exception: ' + error.statusText + ' | Source:ajaxFail in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteOrganizationalLevel() method in OrganizationalLevels.js';
                    logger.logMessage(msg);
                }
            }

        }







        //Docuemnt section strats
        function GetUMSDocDetails(data, event) {
            try {
                try {
                    ViewModel.CurrentUMSId(data.ID());
                    ViewModel.CurrentUMSContent(data.Description());
                    $.ajax({
                        url: "/api/Configuration/GetUMSComments",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders(),
                        data: { TemplateId: data.ID(), CommentType: 'UMSD' }
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in getReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, error) {
                    try {
                        if (jsonResult != null) {
                            var mappedDocDetails = $.map(jsonResult, function (result) {
                                return new ReportDetailsModel(result);
                            });

                            ViewModel.DocumentListFinal([]);
                            ViewModel.DocumentListFinal(mappedDocDetails);
                            $('#AttachmentPopUp').modal('show');
                        }
                        else
                            logger.logError('Some error occured', 'Error', system.getModuleId(ViewModel), true);
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();

                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getReportDetails() method in ReportManagement.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in getReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: getReportDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

        function ReportDetailsModel(item) {
            try {
                var self = this;
                self.DocId = ko.observable($('<div/>').html(item.CommentId).text());
                self.DocComments = ko.observable($('<div/>').html(item.CommentText).text());
                self.DocumentName = ko.observable($('<div/>').html(item.DocumentName).text());
                //self.DocumentUploadedforProfile = ko.observable($('<div/>').html(item.DocumentUploadedforProfile).text());
               // self.DocType = ko.observable($('<div/>').html(item.DocumentType).text());
                self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text())
                self.UserName = ko.observable($('<div/>').html(item.UploadedBy).text());
                self.DocPath = ko.observable($('<div/>').html(item.DocumentPath).text());

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ReportDetailsModel() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }


        function UploadDocument(data) {
            try {

                var Filelist = "";
                var FileName = "";
                var errormsgId = "";
                var ProgressBarMainDivId = "";
                var ProgressMsgId = "";

                var TemplateID = ViewModel.CurrentUMSId();
                var Description = ViewModel.CurrentUMSContent();

                ViewModel.UploadUMSComment($("#UploadTextArea").val().trim());
                errormsgId = '#lbldocError';
                ProgressBarMainDivId = '#ProgressBarMainDiv';
                ProgressMsgId = '#lblProgressMsg';
                FileList = document.getElementById('SummaryFileUploader').files;
                if (FileList.length > 0)
                    FileName = document.getElementById('SummaryFileUploader').files[0].name;

                if (ViewModel.UploadUMSComment() == undefined) {
                    ViewModel.UploadUMSComment("");
                }

                if (FileList.length > 0) {
                    if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PNG'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPG'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPEG'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOCX'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOC'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLS'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PDF'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'CSV'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'TXT'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSX'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSM'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'BMP'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'RTF'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPT'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPTX'
                        | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'MSG') {

                        if (FileList[0].size <= 1073741824) {
                            if (ViewModel.UploadUMSComment().length <= ViewModel.CommentCharsLimit()) {
                                $(errormsgId).text("");
                                $(ProgressMsgId).removeClass('field-validation-error');
                                var FormDataObj = new FormData();
                                FormDataObj.append("File1", FileList[0]);
                                var request = new XMLHttpRequest();
                                $(ProgressBarMainDivId).show();
                                request.onreadystatechange = function () {
                                    if (request.readyState == 1) {
                                        ViewModel.ProgressMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InitializeFileUploadMessage') == -1) ? 'Initializing File Upload...' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InitializeFileUploadMessage')].Name());
                                    }
                                    else if (request.readyState == 4) {
                                        if (request.status == 200) {
                                            if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                ViewModel.ProgressMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage') == -1) ? 'The file has been uploaded successfully.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage')].Name());

                                                var DocName = "";

                                                DocName = document.getElementById('SummaryFileUploader').files[0].name;
                                                SetDocumentComments(TemplateID, DocName, JSON.parse(request.response), ViewModel.UploadUMSComment()).then(function () {
                                                    document.getElementById('SummaryFileUploader').value = '';
                                                    document.getElementById('UploadTextArea').value = '';
                                                    GetUserManualList().then(function () {
                                                        TemplateID = ViewModel.CurrentUMSId();
                                                        GetComments(TemplateID, "UMSD");
                                                    });
                                                });


                                                $(ProgressBarMainDivId).hide();
                                                ViewModel.UploadUMSComment("");
                                                //$('#ProgressBarDiv').hide();
                                                ViewModel.ProgressMessage("");
                                                ViewModel.RemainingChars(ViewModel.CommentCharsLimit());
                                                logger.logSuccess((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage') == -1) ? 'The file has been uploaded successfully.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage')].Name(), 'Success', system.getModuleId(ViewModel), true);
                                            }
                                            else {
                                                $(ProgressBarMainDivId).show();
                                                $(ProgressMsgId).addClass('field-validation-error');
                                                ViewModel.ProgressMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage') == -1) ? 'The file could not be uploaded.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage')].Name());

                                            }
                                        }
                                    }
                                    else
                                        ajaxFail(request, "");

                                };
                                request.upload.addEventListener('progress', function (event) {
                                    ViewModel.ProgressPercent(parseInt((event.loaded / event.total) * 100) + '%');
                                    ViewModel.ProgressMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UploadingFileStatusMessage') == -1) ? 'Uploading File...' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UploadingFileStatusMessage')].Name());
                                });
                                request.withCredentials = true;
                                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                var headers = appsecurity.getSecurityHeaders();
                                headers.__RequestVerificationToken = csrfToken;
                                request.open('POST', '/api/Configuration/FileUploadUMS');
                                request.setRequestHeader('Authorization', headers.Authorization);
                                request.setRequestHeader('RT', headers.RT);
                                request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                request.send(FormDataObj);
                                logger.logMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage') == -1) ? 'The file has been uploaded successfully.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage')].Name);
                                $(ProgressBarMainDivId).hide();
                            }
                            else
                                $(errormsgId).text(((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitBegin') == -1) ? 'Comment cannot exceed' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitBegin')].Name()).toString() + ' ' + ViewModel.CommentCharsLimit() + ' ' + ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitEnd') == -1) ? 'characters.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('4000CommentCharLimitEnd')].Name()).toString());
                        }
                        else
                            $(errormsgId).text(((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageBegin') == -1) ? 'Upload file size cannot exceed' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageBegin')].Name()).toString() + ' ' + (ViewModel.UploadFileSize() / 1048576) + ' ' + ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageEnd') == -1) ? 'MB. Please try uploading a file of lesser size.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageEnd')].Name()).toString());
                    }
                    else
                        $(errormsgId).text(((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidFileFormatMessage') == -1) ? 'Please select a valid file to upload.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidFileFormatMessage')].Name()).toString());
                }
                else
                    $(errormsgId).text(((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectFileToUploadError') == -1) ? 'Please select a file to upload.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SelectFileToUploadError')].Name()).toString());

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString()) {
                                        ViewModel.DashboardVM.NavigatedFrom('Response');
                                        router.navigate("Landing", true);
                                    }
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocuments() method in SurveyResponsePage.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocuments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                };

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

        }

        function SetDocumentComments(TemplateId, DocName, DocPath, CommentText) {
            try {
                
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Configuration/SetUMSDocumentComments?TemplateId=" + TemplateId + "&DocName=" + DocName + "&DocPath=" + DocPath + "&Comments=" + CommentText,
                    headers: headers,
                    type: "POST"
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult.startsWith('INC') || parseInt(jsonResult) <= 0) {
                            if (jsonResult.startsWith('INC')) {
                                var msg = 'An error occurred while saving Comments. May be Because Comment contain some invalid characters or Please contact Administrator.';
                                logger.logError(jsonResult + ' - ' + msg, 'Error', system.getModuleId(ViewModel), true);

                            }
                            else {
                                logger.logError((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage') == -1) ? 'An error occurred while saving Comments. Because Comment contain some invalid characters.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage')].Name(), 'Error', system.getModuleId(ViewModel), true);
                            }
                        }
                        else {
                            ViewModel.CurrentUMSId(jsonResult);
                        }
                    })
                    .fail(function () {

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function GetComments(TemplateId, Type) {
            try {

                return $.ajax({
                    url: "/api/Configuration/GetUMSComments",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TemplateId: TemplateId, CommentType: Type }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetComments() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        var mappedDocDetails = $.map(jsonResult, function (result) {
                            return new ReportDetailsModel(result);
                        });

                        ViewModel.DocumentListFinal([]);
                        ViewModel.DocumentListFinal(mappedDocDetails);
                        ViewModel.RemainingChars(ViewModel.CommentCharsLimit());
                    }
                    else
                        logger.logError((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured') == -1) ? 'An error occurred. Please contact your Application Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AnErrorOccured')].Name(), 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function DocumentCommentModel(item) {
            try {
                var self = this;
                self.DCommentText = ko.observable(item.CommentText);
                self.DCommentId = ko.observable(item.CommentId);
                self.DUploadedBy = ko.observable(item.UploadedBy);
                self.DUploadedDate = ko.observable(item.UploadedDate);
                self.DIsCurrentUser = ko.observable(item.IsCurrentUser);
                self.DocumentName = ko.observable(item.DocumentName);
                self.DocumentPath = ko.observable(item.DocumentPath);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DocumentCommentModel() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function OcKeypress(data, event) {
            try {
                if (event.which === 16 || event.which === 17 || event.which === 18 || event.which === 35 || event.which === 36 || event.which === 46 || event.which === 8 || (event.which >= 112 && event.which <= 123))
                    return true;
                else {
                    if (event.currentTarget.value.length >= ViewModel.CommentCharsLimit()) {
                        return false;
                    }
                    return true;
                }
            }
            catch (e) {
                var msg = 'exception' + e + 'source in OcKeypress() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function OcKeyUp(data, event) {
            try {
                ViewModel.RemainingChars(ViewModel.CommentCharsLimit() - event.currentTarget.value.length);
            }
            catch (e) {
                var msg = 'exception' + e + 'source in OcKeypress() in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DownloadDocument(data, event) {
            try {
                
                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/Configuration/CheckFileIfExist",
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { CommentId: data.DocId(), FileName: data.DocumentName(), FilePath: data.DocPath() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DownloadDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {

                    if (jsonResult) {
                        var payLoad = {
                            t: appsecurity.getAuthenticationInfo(), FilePath: data.DocPath(), FileName: data.DocumentName()
                        };
                        utils.postAndRedirect(rootPath + "/FileDownload/DownloadFile", payLoad, '_blank');
                    }
                    else
                        logger.logError(ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDownload') == -1) ? 'The requested document is not available for download. Please contact your Application Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDownload')].Name], 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DownloadDocument() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownloadDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

        }

        

        function DeleteDocument(data) {
            try {
                app.showMessage(
                    ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteDocConfirmation') == -1) ? 'Are you sure you want to delete this document?' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteDocConfirmation')].Name)
                    , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteDocumentHeading') == -1) ? 'Delete Document' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteDocumentHeading')].Name)
                    , [((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name)
                        , ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name)])
                    .then(function (option) {
                        if (option === ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString()) {
                            DeleteUMSDocument(data);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteControlQuestionPopUp() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function DeleteUMSDocument(data) {
            try {
                
                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/Configuration/CheckFileIfExist",
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { CommentId: data.DocId(), FilePath: data.DocPath(), FileName: data.DocumentName() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DeleteDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {
                    if (jsonResult) {
                        DeleteDocComments(data);
                    }
                    else
                        logger.logError(ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDelete') == -1) ? 'The requested document is not available to delete. Please contact your Application Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDelete')].Name], 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocument() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

        }

        function DeleteDocComments(data) {
            try {
                
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/DeleteDocComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        CommentId: data.DocId(),
                        CommentType: 'UMSD',
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteDocComments() in SurveyDashboard.js'
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {

                    if (result >= 0) {
                        DeleteFile(data);
                    }
                    else {
                        //logger.logError('An error occurred while deleting the document.', 'Error', system.getModuleId(ViewModel), true);
                        var redirectBack = confirm((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetFailMessage') == -1) ? 'You are no longer allowed to perform Save/Edit operation. The Survey is either moved to another state or picked by another user. You will be redirected to Landing Page.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetFailMessage')].Name);
                        if (redirectBack === true) {
                            ViewModel.DashboardVM.NavigatedFrom('Response');
                            router.navigate("landing", true);
                        }
                        else {
                            app.showMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage') == -1) ? 'The Survey is either moved to another state or picked by another user. You are not allowed to perform Save/Edit operation. Please click \'OK\' to redirect to Landing Page.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveySetErrorMessage')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage') == -1) ? 'Action cannot be performed' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString()], false, { buttonClass: "fa fa-check btn", primaryButtonClass: "secondary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                                .then(function (option) {
                                    if (option === " " + ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString()) {
                                        ViewModel.DashboardVM.NavigatedFrom('Response');
                                        router.navigate("landing", true);
                                    }
                                });
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteDocComments() in SurveyResponse.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocComments() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteDocComments() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }



        function DeleteFile(data) {
            try {
                
                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/Configuration/DeleteFileIfExist",
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { CommentId: data.DocId(), FilePath: data.DocPath(), FileName: data.DocumentName() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DeleteDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {
                    if (jsonResult) {
                        GetComments(ViewModel.CurrentUMSId(), "UMSD");
                        logger.logSuccess((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocDeleteSuccessMessage') == -1) ? 'Document deleted successfully.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DocDeleteSuccessMessage')].Name(), 'Success', system.getModuleId(ViewModel), true);
                    }
                    else
                        logger.logError(ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDelete') == -1) ? 'The requested document is not available to delete. Please contact your Application Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDelete')].Name], 'Error', system.getModuleId(ViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocument() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

        }



        

       

    });


